import type { ReactNode } from "react"

export function AuthProvider({ children }: Readonly<{ children: ReactNode }>) {
  // Auth wrapping is now handled in main.tsx with AppWithAuth
  // This provider is kept for backward compatibility
  return <>{children}</>
}
